export default "__VITE_ASSET__39f1faeb__"